import {doSuccessFailureActions} from '../_utils/actions.js';

export const SEND_MESSAGE = doSuccessFailureActions('SEND_MESSAGE');
export const JUSTIFY_MESSAGE = doSuccessFailureActions('JUSTIFY_MESSAGE');

export function sendMessage(payload) {
  return {type: SEND_MESSAGE.do, payload: payload}
}

export function sendMessageSuccess(payload) {
  return {type: SEND_MESSAGE.success, payload: payload}
}

export function sendMessageFailure(payload, err) {
  return {type: SEND_MESSAGE.failure, payload: payload, err: err}
}

export function justifyMessage(payload) {
  return {type: JUSTIFY_MESSAGE.do, payload: payload}
}

export function justifyMessageSuccess(payload) {
  return {type: JUSTIFY_MESSAGE.success, payload: payload}
}

export function justifyMessageFailure(payload) {
  return {type: JUSTIFY_MESSAGE.failure, payload: payload}
}



// WEBPACK FOOTER //
// ./src/redux/messages/actions.js